import React, {memo, useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {useNavPos} from '../../../hooks';

import {detailsFeatureSelector} from '../../../mapsight-glue/store/selectors';
import {createHeartSelector} from '../../store/selectors';
import {setHeart} from '../../store/actions';

export default memo(function Heart() {
	const dispatch = useDispatch();
	const navPos = useNavPos();

	const feature = useSelector(detailsFeatureSelector);
	const heartSelector = useMemo(
		_ => createHeartSelector(navPos?.app?.uri, feature?.id),
		[navPos?.app?.uri, feature?.id]
	);
	const heart = useSelector(heartSelector);
	const onHeart = useCallback(
		() => dispatch(setHeart(navPos?.app?.uri, feature?.id, !heart?.heart)),
		[navPos?.app?.uri, feature?.id, heart?.heart]
	);

	return (
		<ul>
			{feature &&
			<li className={`stade-widget__rating__heart ${heart?.heart ? 'stade-widget__rating__heart--on' : ''}`} >
				<button onClick={onHeart}>
					<span>{navPos.app.lang === 'en'?'Favorite':'Lieblingsplatz'}</span>
				</button>
			</li>
			}
		</ul>
	);
});
